import React from "react";
import { useNavigate } from "react-router-dom";
import { Chip, Tooltip } from "@mui/material";
import AccountBalanceWalletOutlinedIcon from "@mui/icons-material/AccountBalanceWalletOutlined";
import { useBilling } from "../../context/BillingContext";
import { formatRupeesFromPaisa } from "./billingFormat";

const WalletBalanceChip = () => {
    const navigate = useNavigate();
    const { isCreditBased, wallet } = useBilling();
    if (!isCreditBased || !wallet) return null;

    const empty = Number(wallet.current_credit) <= 0;
    const color = empty ? "#b91c1c" : "#166534";
    const bg = empty ? "#fef2f2" : "#f0fdf4";
    const border = empty ? "#fecaca" : "#bbf7d0";

    return (
        <Tooltip title={empty ? "Wallet is empty. Open Credits Information to add credits." : "Open Credits Information"}>
            <Chip
                icon={<AccountBalanceWalletOutlinedIcon sx={{ fontSize: 16 }} />}
                label={formatRupeesFromPaisa(wallet.current_credit)}
                size="small"
                onClick={() => navigate("/credits-info")}
                sx={{
                    height: 28,
                    fontWeight: 700,
                    backgroundColor: bg,
                    color,
                    border: `1px solid ${border}`,
                    "& .MuiChip-icon": { color, ml: "6px" },
                }}
            />
        </Tooltip>
    );
};

export default WalletBalanceChip;
